const steps = ["Cancion", "Video", "Acordes", "Sync", "Preview", "Publicar"];

const AdminMusicCatalogWizard = ({ activeStep = 0 }) => (
  <nav aria-label="Flujo de publicacion musical" className="steel-scroll-soft flex gap-2 overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.04] p-2">
    {steps.map((step, index) => (
      <span
        key={step}
        className={`flex min-h-10 shrink-0 items-center gap-2 rounded-xl px-3 text-sm font-semibold ${
          index <= activeStep ? "bg-cyan-300/15 text-cyan-100" : "text-slate-500"
        }`}
      >
        <span className={`grid h-6 w-6 place-items-center rounded-full text-xs ${index <= activeStep ? "bg-cyan-300 text-slate-950" : "bg-white/10"}`}>{index + 1}</span>
        {step}
      </span>
    ))}
  </nav>
);

export default AdminMusicCatalogWizard;
